const ALL_ORGS_OVERRIDE_KEY = 'allOrgsOverride';
export const redirectToImport = ({ path, allOrgsOverride = false, navService, }) => {
    localStorage.setItem(ALL_ORGS_OVERRIDE_KEY, allOrgsOverride ? 'true' : 'false');
    navService.goToPath(path);
};
//# sourceMappingURL=import-redirect.js.map